import Popover from "../PopOver";
import React from "react";
import LinkButton from "../LinkButton";
import styles from "./CopyButton.module.scss";

const CopyButton = ({ hcmID, recordID, idNumber, hasLeftIcon }) => {
  const [idCopied, setIdCopied] = React.useState("");
  const [recordId, setRecordId] = React.useState("");
  const [isVisible, setVisible] = React.useState(true);

  const copyToClipboardId = async (gid, recordId) => {
    navigator.clipboard.writeText(gid);
    setIdCopied(gid);
    setRecordId(recordId);
    setVisible(true);
    await sleep(5000);
    setVisible(false);
    setIdCopied("");
    setRecordId("");
  };

  const sleep = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  return (
    <div className={styles.base + hasLeftIcon ? styles.floatRight : ""}>
      <LinkButton
        icon="copy"
        title="Click to copy HCM ID/EID"
        onClick={() => {
          copyToClipboardId(hcmID, recordID);
        }}
        className={
          idCopied === hcmID && recordId === recordID && isVisible
            ? styles.copiedIcon
            : null
        }
      >
        {idNumber}
      </LinkButton>

      {recordId === recordID && isVisible && (
        <Popover
          placement="right"
          setVisible={setVisible}
          spacing={1}
          target={<></>}
          valign="top"
          visible={idCopied === hcmID}
          className={styles.popover}
        >
          {hcmID} Copied
        </Popover>
      )}
    </div>
  );
};

export default CopyButton;
